<template>
    <el-dialog
            title="编辑名称"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            width="30%"
            :before-close="handleClose">
        <div>
            <ElementForm
                ref="form"
                :form.sync="newForm"
            />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import * as ResultServer from '../../../../api/result'
    import * as CommonServer from "../../../../api/common";
    export default {
        name: "editName",
        props: {
            type: String,
            editNameData: [Object,Array],
            visible: {
                type: Boolean,
                default: true
            },
        },
        watch:{
            type(vl){this.newType = vl},
            newType(vl){this.$emit('update:type', vl)},
            editNameData(vl){this.newEditNameData = vl},
            newEditNameData(vl){this.$emit('update:editNameData', vl)},
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){this.$emit('update:visible', vl)},
        },
        mounted() {
            this.$nextTick(()=>{
                this.init()
            })
        },
        data(){
            return {
                newType: this.type,
                newEditNameData: this.editNameData,
                dialogVisible: this.visible,
                newForm:[
                    {
                        "name": "名称",
                        "value": this.editNameData.name,
                        "type": "Input",
                        "props": {
                            "placeholder": "请输入",
                            "rules": {
                                "required": true,
                                "message": "请输入",
                                "target": "blur"
                            }
                        }
                    }
                ]
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false
            },
            async submit() {
                let state = this.$refs.form.validateForm()
                let res = null
                let obj = {
                    id: this.newEditNameData.id,
                    clientsId: this.newEditNameData.clients_id,
                    categoryId :this.newEditNameData.category_id,
                    name:this.newForm[0].value,
                    title:this.newEditNameData.title,
                    type:this.newEditNameData.type
                }
                if(state){
                    let detail = {}
                    switch (this.type) {
                        case '我的课件':
                            detail = await ResultServer.getResultDetail({id: this.newEditNameData.id, clientsId: this.newEditNameData.clients_id})
                            obj = {
                                id: this.newEditNameData.id,
                                "category_id": detail.data.category_id,
                                "title": detail.data.title,
                                "type": detail.data.type,
                                "cover": detail.data.cover,
                                "attributes":{
                                    //h5_original: detail.data.attr_last.h5_original,
                                    //"h5_remote": detail.data.attr_last.h5_remote,
                                    // "cocos_original": detail.data.attr_last.cocos_original,
                                    // "cocos_remote": detail.data.attr_last.cocos_remote
                                },
                                clientsId: this.newEditNameData.clients_id, name:this.newForm[0].value }
                            res = await ResultServer.updateResult(obj)
                            break;
                        case '我的模版':
                            detail = await CommonServer.default.getResourceDetail({id: this.newEditNameData.id, clientsId: this.newEditNameData.clients_id})
                            obj = {
                                id: this.newEditNameData.id,
                                "sort": 'template',
                                "category_id": detail.data.category_id,
                                "title": detail.data.title,
                                "type": detail.data.type,
                                "cover": detail.data.cover,
                                "attributes":{
                                    h5_original: detail.data.attributes.h5_original,
                                    //"h5_remote": detail.data.attributes.h5_remote,
                                    // "cocos_original": detail.data.attributes.cocos_original,
                                    // "cocos_remote": detail.data.attributes.cocos_remote
                                },
                                clientsId: this.newEditNameData.clients_id, name:this.newForm[0].value }
                            res = await CommonServer.default.updateResource(obj)
                            break;
                        case '公共模版':
                            detail = await CommonServer.default.getResourceShopDetail({id: this.newEditNameData.id, clientsId: this.newEditNameData.clients_id})
                            obj = {
                                id: this.newEditNameData.id,
                                "sort": 'template',
                                "category_id": detail.data.category_id,
                                "title": detail.data.title,
                                "type": detail.data.type,
                                "cover": detail.data.cover,
                                "attributes":{
                                    h5_original: detail.data.attributes.h5_original,
                                    //"h5_remote": detail.data.attributes.h5_remote,
                                    // "cocos_original": detail.data.attributes.cocos_original,
                                    // "cocos_remote": detail.data.attributes.cocos_remote
                                },
                                clientsId: this.newEditNameData.clients_id,
                                name:this.newForm[0].value }
                            res = await CommonServer.default.updateResourceShop(obj)
                            break;
                    }
                    if(res){
                        this.$message.success('编辑成功')
                        this.$emit('success')
                        this.handleClose()
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
